import { useTranslation } from "react-i18next";
import TabsNavigationBar from "../../components/bar/TabsNavigationBar/TabsNavigationBar";

function BankingNavigationBar(props) {
    const { t } = useTranslation();
    return (
        <TabsNavigationBar
            multipleLocationKey={props.multipleLocationKey}
            pages={[
                {
                    label: t("headers.bankings_register"),
                    link: "/financial-panel/banking/",
                },
                {
                    label: t("headers.banks"),
                    link: "/financial-panel/bank/",
                },
            ]}
        />
    );
}

export default BankingNavigationBar;
